var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThermax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 843.5 1045.8",
    style: {
      enableBackground: "new 0 0 843.5 1045.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#ED3438;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M765.3,975.2l-48.7,70.6h27.7l35.3-47.7l33.4,47.7h30.5l-49.6-70.6l49.6-68.7H813l-33.4,47.7l-35.3-47.7 h-27.7L765.3,975.2z M667,943.7l14.3,40.1h-28.6L667,943.7z M656.5,906.5l-60.1,139.3H625l17.2-35.3h47.7l17.2,35.3l20-26.7 l-53.4-112.6L656.5,906.5L656.5,906.5z M436.1,1045.8h26.7v-104l38.2,104h20l35.3-104v104H584V906.5h-35.3l-40.1,105.9 l-37.2-105.9h-35.3V1045.8z M352.1,931.3h14.3l11.5,1l8.6,3.8l4.8,5.7l1.9,8.6l-1.9,9.5l-4.8,5.7l-7.6,3.8l-10.5,1h-16.2 L352.1,931.3z M364.5,906.5h-40.1v139.3h27.7v-54.4l37.2,54.4h31.5l-36.3-52.5l7.6-2.9l6.7-3.8l6.7-5.7l6.7-5.7l3.8-5.7l2.9-6.7 l1-6.7l1-5.7l-1-6.7l-1-7.6l-2.9-6.7l-3.8-6.7l-3.8-2.9l-4.8-4.8l-5.7-3.8l-6.7-2.9l-5.7-1l-5.7-1L364.5,906.5L364.5,906.5z  M225.2,906.5v139.3h76.3v-26.7h-49.6v-31.5h47.7v-22.9h-47.7v-33.4h51.5v-24.8H225.2z M95.4,906.5v139.3h27.7v-60.1h49.6v60.1 h26.7V906.5h-26.7v56.3h-49.6v-56.3H95.4z M1.9,931.3h29.6v114.5h26.7V931.3H83v-24.8H1.9V931.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "399.8,79.2 399.8,818.7 204.2,820.6 204.2,401.7 0,401.7 0,0 310.1,1.9 311.1,1.9 313.9,1.9  316.8,1.9 320.6,1.9 336.8,3.8 351.1,7.6 364.5,14.3 376,23.9 385.5,35.3 393.1,48.7 397.9,63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "434.2,77.3 434.2,551 434.2,820.6 629.8,820.6 629.8,401.7 835.9,401.7 835.9,0 521,0 519.1,0  517.2,0 516.2,0 515.3,0 499,1.9 484.7,5.7 470.4,12.4 459,22 449.4,33.4 441.8,46.8 436.1,61.1  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermax);
export default __webpack_public_path__ + "static/media/thermax.9068e7df1d7f668d081f59bb50377d20.svg";
export { ForwardRef as ReactComponent };